import React from "react";
import { Autocomplete, TextField, InputLabel } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import {
  FilterRowItem,
  MultiSelectCheckbox,
  MultiSelectLi,
  MultiSelectText,
} from "./styles";

interface Props {
  label: string;
  filterKey: string;
  placeholder?: string;
  optionsObjArray: Array<{ id: string | number; label: string }> | Array<never>;
}

export const AutoCompleteProfessions = ({
  label,
  filterKey,
  placeholder,
  optionsObjArray,
  ...rest
}: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onFilterValueChange = (e: any, data: any) => {
    e.preventDefault();
    const ids = data?.map((item: any) => item.id) as string[];
    const counts = {} as any;
    for (let i = 0, l = ids.length; i < l; i++) {
      counts[ids[i]] = (counts[ids[i]] || 0) + 1;
    }
    const result = ids.filter((item) => counts[item] <= 1);
    setSearchParams((params) => {
      if (result.length === 0) params.delete(filterKey);
      else params.set(filterKey, result.toString());
      if (filterKey === "profession") params.delete("subprofession");
      return params;
    });
  };

  const value = React.useMemo(() => {
    const val = searchParams.get(filterKey) || "";
    if (!val) return [];
    const ids = val.split(",");
    const vals = optionsObjArray.filter((item) =>
      ids.includes(item.id.toString())
    );
    return vals;
  }, [searchParams, optionsObjArray]);

  return (
    <FilterRowItem>
      <InputLabel>{label}</InputLabel>
      <Autocomplete
        multiple
        value={value}
        disableCloseOnSelect
        sx={{ minWidth: 300 }}
        options={optionsObjArray}
        onChange={onFilterValueChange}
        renderInput={(params) => (
          <TextField {...params} placeholder={placeholder} />
        )}
        renderOption={(props: any, option: any) => (
          <MultiSelectLi {...props}>
            <MultiSelectCheckbox
              checked={
                value.findIndex(
                  (item) => item.id.toString() === option.id.toString()
                ) > -1
              }
            />
            <MultiSelectText primary={option.label} />
          </MultiSelectLi>
        )}
      />
    </FilterRowItem>
  );
};
